import { render, staticRenderFns } from "./SpectMiocardicaList.vue?vue&type=template&id=5c66cb8e"
import script from "./SpectMiocardicaList.vue?vue&type=script&lang=js"
export * from "./SpectMiocardicaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports